import { Component, computed, forwardRef, inject, Injector, input, model, OnInit, signal } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { DxTextBoxModule } from 'devextreme-angular';
import { ValueChangedEvent } from 'devextreme/ui/text_box';
import { DECORATOR_HOST, DecoratorHost } from '../../../directives/decorator-host';

@Component({
  selector: 'app-textbox',
  templateUrl: './textbox.component.html',
  styleUrl: './textbox.component.scss',
  imports: [DxTextBoxModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextboxComponent),
      multi: true
    },
    {
      provide: DECORATOR_HOST,
      useExisting: forwardRef(() => TextboxComponent)
    }
  ],
  host: {
    class: 'link-component'
  }
})
export class TextboxComponent implements OnInit, ControlValueAccessor, DecoratorHost {
  private injector = inject(Injector);
  ngControl: NgControl = null;

  readonly value = model<string>('');
  readonly readonly = input<boolean>(false);
  readonly disabled = model<boolean>(false);

  private readonly inputId = signal<string | null>(null);
  protected readonly inputAttr = computed<Record<string, string>>(() => this.inputId() ? { id: this.inputId() } : {});

  ngOnInit(): void {
    try {
      this.ngControl = this.injector.get(NgControl);
    }
    catch {
      // No NgControl
    }
  }

  get control(): FormControl {
    return this.ngControl?.control as FormControl;
  }

  get isValid(): boolean {
    return !this.control || (this.control.invalid !== true || (this.control.pristine && this.control.untouched));
  }

  onValueChanged(e: ValueChangedEvent): void {
    if (e.value !== this.value()) {
      this.onChange(e.value);
      this.value.set(e.value as string);
    }
  }

  /*
   * ControlValueAccessor interface methods
   */

  writeValue(obj: string): void {
    this.value.set(obj);
  }

  private onChange: (value: unknown) => void = () => { };
  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  onTouched: () => void = () => { };
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(!!isDisabled);
  }


  /*
   * DecoratorHost interface methods
   */

  setInputId(inputId: string | null): void {
    this.inputId.set(inputId);
  }

  getInputId(): string | null {
    return this.inputId();
  }
}
